import { isGPCustomDomain } from 'utils/domain';
// import { isSsrDisabled } from 'utils/ssr';

export const GP_ROOT_ROUTE = (isGPCustomDomain() ? '/gp' : '') + '/:title/:guestPortalId';
export const GP_LANDING_ROUTE = GP_ROOT_ROUTE + '/:itemType/:itemId';
export const GP_FORBIDDEN_GP_ROUTE = GP_ROOT_ROUTE + '/forbidden';

// export const GP_AUTH_SIGNIN_ROUTE = isSsrDisabled() ? GP_ROOT_ROUTE + '/auth/signin' : GP_ROOT_ROUTE;

export const GP_AUTH_SIGNIN_ROUTE = '/guest/auth/login';
export const GP_PRIVACY_POLICY_ROUTE = '/privacy_policy/:guestPortalId';
